module.exports = __webpack_public_path__ + "static/media/pla-filaments-3.544557cd.jpg";